// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__YgkX0","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__uIEQr"};